import type { ExpertAssistMessage } from "../shared-types";

export const baseDefaultMessage = {
    type: "Default",
    status: "active",
    isUnread: true,
};

export const fallbackDefaultMessages = [
    {
        key: "firstOpen",
        text: `Hey $EXPERT_NAME! 👋 How can I help you today?`,
        id: `firstOpen_${crypto.randomUUID()}`,
        tag: "New chat",
        ...baseDefaultMessage,
    },
    {
        key: "inCallDeviceInfo",
        text: "Need help troubleshooting? Ask away—I’m here to assist!",
        id: `newCall_${crypto.randomUUID()}`,
        tag: "New call",
        ...baseDefaultMessage,
    },
    {
        key: "manualReset",
        text: "The chat was reset. I’m ready to help!",
        id: `manualReset_${crypto.randomUUID()}`,
        ...baseDefaultMessage,
    },
    {
        key: "offCall",
        text: `How can I help you today?`,
        id: `offCall_${crypto.randomUUID()}`,
        tag: "Off-call chat",
        ...baseDefaultMessage,
    },
] as ExpertAssistMessage[];
export type ResetReason = keyof typeof fallbackDefaultMessages;
